const SignInService = (() => {
    /**
     * @param {string} country 
     * @param {string} countryText 
     * @param {string} lang 
     * @param {object} userData 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const r4SignIn = (country, countryText, lang, userData) => {
        return new Promise((resolve, reject) => {
            try {
                triggerRouterCreateSession(country, lang) //add create session api
                    .then(({ sessionId, encryptedSessionId, clientIp, dataCenter }) => {
                        if (sessionId) {
                            triggerRouterSignInCustomer(sessionId, country, lang, userData) //sign api
                                .then((signInData) => {
                                    if (signInData?.data?.signIn?.errorCode) {
                                        resolve({
                                            success: false,
                                            data: null,
                                            message: null, //signInData?.data?.signIn?.message,
                                            error: null, //signInData,
                                            urlType: 'login',
                                        });
                                    } else {
                                        window.queryData.triggerCustomerProfile(
                                            sessionId,
                                            signInData?.data?.signIn?.token?.accessToken,
                                            country,
                                            lang
                                        ).then((customerProfile) => {
                                            if (customerProfile?.data?.customerProfile?.errorCode) {
                                                resolve({
                                                    success: false,
                                                    data: null,
                                                    message: null, //customerProfile?.data?.customerProfile?.message,
                                                    error: null, //customerProfile,
                                                    urlType: 'login',
                                                });
                                            } else {
                                                setDataInStorageR4(
                                                    customerProfile,
                                                    signInData,
                                                    lang,
                                                    userData,
                                                    country,
                                                    sessionId,
                                                    encryptedSessionId,
                                                    clientIp,
                                                    dataCenter
                                                );
                                                StorageService.setDataInStorage(
                                                    country,
                                                    lang,
                                                    sessionId,
                                                    encryptedSessionId,
                                                    userData,
                                                    countryText,
                                                    customerProfile
                                                );

                                                const accNumber = customerProfile?.data?.customerProfile?.customer?.accountNumber;
                                                sessionStorage.setItem('AccountNumber', accNumber);
                                                const prepaidToken = signInData?.data?.signIn?.token?.prepaidToken || "";
                                                sessionStorage.setItem('prepaidToken', prepaidToken);

                                                resolve({
                                                    success: true,
                                                    data: null,
                                                    message: null,
                                                    error: null,
                                                    urlType: 'start',
                                                });
                                            }
                                        })
                                            .catch((error) => {
                                                console.error("error from trigger customerProfile : ", error);
                                                resolve({
                                                    success: false,
                                                    data: null,
                                                    message: null,
                                                    error,
                                                    urlType: null,
                                                });
                                            });
                                    }
                                })
                                .catch((error) => {
                                    console.error("error from trigger SingIn Session : ", error);
                                    resolve({
                                        success: false,
                                        data: null,
                                        message: null,
                                        error,
                                        urlType: null,
                                    });
                                });
                        }
                    })
                    .catch((error) => {
                        console.error("error from trigger create Session : ", error);
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    });
            } catch (error) {
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} host 
     * @param {object} userData 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const r3SignIn = (country, lang, host, userData) => {
        return new Promise((resolve, reject) => {
            try {
                const createSessionSingonR3 = triggerCreateSession(country, lang, host);

                httpRequest.post(createSessionSingonR3.createSessionurl, createSessionSingonR3.reqPayload, { "Content-type": "application/json" })
                    .then((response) => {
                        const clientIp = response?.security?.client_ip ? response.security.client_ip : '245024209201';
                        const sessionId = response?.security?.session.id;
                        const encryptedSessionId = response?.security?.session?.encrypted_session_id;
                        setCookieOnCreateSessionResponse(response);
                        if (clientIp && sessionId) {
                            triggerCustomerSignOn(country, lang, sessionId, clientIp, userData, host)
                                .then((singOnResponse) => {
                                    if (singOnResponse?.error?.code) {
                                        sessionStorage.setItem('quickLoginErrorResponse', JSON.stringify(singOnResponse));

                                        resolve({
                                            success: false,
                                            data: null,
                                            message: null,
                                            error: null,
                                            urlType: 'login',
                                        });
                                    } else {
                                        const accNumber = singOnResponse?.gatewayCustomer?.preferredCustomer?.accountNbr;
                                        const successType = 'sc_login_success';
                                        triggerGetTransactionDetails(sessionId, clientIp, accNumber, host)
                                            .then((transactionResponse) => {

                                                setR3SendeGatewayrDetails(sessionId, encryptedSessionId, country, lang, userData, singOnResponse, successType);
                                                updateUserIdentity(singOnResponse);

                                                triggerGetCustomerVerificationStatus(sessionId, clientIp, accNumber, host)
                                                    .then((customerVerificationResponse) => {
                                                        setR3CustomerVerificationStatus(customerVerificationResponse);
                                                        triggerGetLoyaltycards(sessionId, clientIp, accNumber, host)
                                                            .then((loyalityResponse) => {
                                                                setR3LoyalityCard(loyalityResponse);
                                                                if (userData?.rememberMeChecked) {
                                                                    CookieService.setCookie("User_Email", userData?.emailId, 365, '/', true, ".westernunion.com");
                                                                }
                                                                const urlType = transactionResponse?.transactions?.transaction?.length > 0 ? 'history' : 'start';

                                                                resolve({
                                                                    success: true,
                                                                    data: null,
                                                                    message: null,
                                                                    error: null,
                                                                    urlType,
                                                                });
                                                            }).catch(error => {
                                                                console.error(error);
                                                                resolve({
                                                                    success: false,
                                                                    data: null,
                                                                    message: null,
                                                                    error,
                                                                    urlType: null,
                                                                });
                                                            })
                                                    }).catch(error => {
                                                        console.error(error);
                                                        resolve({
                                                            success: false,
                                                            data: null,
                                                            message: null,
                                                            error,
                                                            urlType: null,
                                                        });
                                                    });
                                            }).catch(error => {
                                                console.error(error);
                                                resolve({
                                                    success: false,
                                                    data: null,
                                                    message: null,
                                                    error,
                                                    urlType: null,
                                                });
                                            })
                                    }
                                }).catch(error => {
                                    console.error(error)
                                    resolve({
                                        success: false,
                                        data: null,
                                        message: null,
                                        error,
                                        urlType: null,
                                    });
                                })
                        } else {
                            resolve({
                                success: false,
                                data: null,
                                message: null,
                                error: null,
                                urlType: null,
                            });
                        }
                    }).catch((error) => {
                        resolve({
                            success: false,
                            data: null,
                            message: null,
                            error,
                            urlType: null,
                        });
                    });
            } catch (error) {
                console.error('error from trigger Session API  : ', error)
                resolve({
                    success: false,
                    data: null,
                    message: null,
                    error,
                    urlType: null,
                });
            }
        });
    };

    /**
     * @param {string} country 
     * @param {string} countryText 
     * @param {string} lang 
     * @param {string} host 
     * @param {object} userData 
     * @param {boolean} isR4 
     * 
     * @return {object} - { success, data, message, error, urlType }
     */
    const signIn = (country, countryText, lang, host, userData, isR4 = false) => {
        if (isR4) {
            return r4SignIn(country, countryText, lang, userData);
        }

        return r3SignIn(country, lang, host, userData);
    };

    return {
        signIn,
        r3SignIn,
        r4SignIn,
    };
})();
